var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#fbfbfb",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.825 13.0001H20C20.2833 13.0001 20.5208 12.9043 20.7125 12.7126C20.9042 12.5209 21 12.2834 21 12.0001C21 11.7168 20.9042 11.4793 20.7125 11.2876C20.5208 11.0959 20.2833 11.0001 20 11.0001H5.825L7.2 9.60011C7.4 9.40011 7.49583 9.16678 7.4875 8.90011C7.47917 8.63344 7.375 8.40011 7.175 8.20011C6.975 8.01678 6.7375 7.92094 6.4625 7.91261C6.1875 7.90428 5.95833 8.00011 5.775 8.20011L2.7 11.3001C2.5 11.5001 2.4 11.7334 2.4 12.0001C2.4 12.2668 2.5 12.5001 2.7 12.7001L5.8 15.8001C5.98333 15.9834 6.2125 16.0751 6.4875 16.0751C6.7625 16.0751 7 15.9834 7.2 15.8001C7.4 15.6001 7.5 15.3626 7.5 15.0876C7.5 14.8126 7.4 14.5751 7.2 14.3751L5.825 13.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowIcon);
export default __webpack_public_path__ + "static/media/left_arrow_icon.945f8ad8180adc536efd9c62bfcedc74.svg";
export { ForwardRef as ReactComponent };